import { render, staticRenderFns } from "./PDFLoader515.vue?vue&type=template&id=8eb64106&scoped=true&"
import script from "./PDFLoader515.vue?vue&type=script&lang=ts&"
export * from "./PDFLoader515.vue?vue&type=script&lang=ts&"
import style0 from "./PDFLoader515.vue?vue&type=style&index=0&id=8eb64106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb64106",
  null
  
)

export default component.exports